<template>
    <div class="feedback pb-4 pt-0">
        
        <div class="filter mb-4">
            <base-input>
                <el-select v-model="selectedCompetencies"
                        multiple
                        class="select-info"
                        :placeholder="$t('feedbacks.select-competencies')">

                    <el-option v-for="competency in competencies"
                            :key="competency.id"
                            :label="competency['name_'+registration.degree.lang]"
                            :value="competency.id"
                            class="select-primary"
                    >
                        {{ competency['name_'+registration.degree.lang] }}
                    </el-option>

                </el-select>
            </base-input>
            <div class="text-right mt-2">
                <base-button type="white mr-1" size="sm" @click="selectAll">
                    {{ $t('common.select-all') }}
                </base-button>
                
                <base-button type="white" size="sm" @click="unselectAll">
                    {{ $t('common.unselect-all') }}
                </base-button>
            </div>
        </div>

        <div v-if="!filteredFeedbacks.length">
            <p class="text-center">{{ $t('feedbacks.no-feedback') }}</p>
        </div>
        
        <div v-else class="timeline timeline-one-side" data-timeline-content="axis" data-timeline-axis-style="dashed">
            <div v-for="(item, index) in filteredFeedbacks" :key="index">
                <div class="timeline-block"
                    :class="{'timeslot-block': !item.type, 'feedback-block': item.type}">

                    <span class="timeline-step badge-default">
                        <i class="fas fa-thumbtack"></i>
                    </span>
                    
                    <div class="timeline-content">

                        <feedback v-if="item.type"
                            :feedback="item" :lang="registration.degree.lang"
                            :show-author="true"
                            :registration="registration"
                            :simulation="simulation"
                        >
                        </feedback>

                        <timeslot-feedbacks v-if="!item.type"
                            :timeslot="item" :lang="registration.degree.lang"
                            :show-author="true"
                            :selectedCompetencies="selectedCompetencies"
                            :registration="registration"
                            :simulation="simulation"
                        >
                        </timeslot-feedbacks>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import CrudClient from '@trax/classes/CrudClient'
    import Feedback from './Feedback'
    import TimeslotFeedbacks from './TimeslotFeedbacks'

    export default {

        components: {
            Feedback, TimeslotFeedbacks
        },

        props: {
            
            modal: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },
            
            simulation: {
                type: Object,
                required: true
            },

            competencies: {
                type: Array,
                required: true
            },
        },

        data() {
            return {
                client: new CrudClient('/astral/api/front/dashboard/feedbacks', {
                    registration_id: this.registration.id,
                    simulation_id: this.simulation.id,
                }),
                feedbacks: [],
                selectedCompetencies: [],
            }
        },

        created() {
            this.list()
        },

        watch: {
            modal(val) {
                if (val.show) {
                    // The modal has just been opened. Update the list.
                    this.list()
                }
            }
        },

        computed: {
            filteredFeedbacks() {
                return this.feedbacks.filter(item => {
                    return (item.type && this.itemVisible(item))
                     || (item.feedbacks && item.feedbacks.length && this.itemsVisible(item.feedbacks))
                })
            },
        },

        methods: {
            
            itemVisible(item) {
                if (this.selectedCompetencies.length == 0) {
                    return true
                }
                if (item.type == 'position') {
                    return true
                }
                const itemCompetencies = item.competencies.map(competency => competency.id)
                const intersect = this.selectedCompetencies.filter(x => itemCompetencies.includes(x))
                return intersect.length > 0
            },

            itemsVisible(items) {
                for (let index in items) {
                    if (this.itemVisible(items[index])) {
                        return true
                    }
                }
                return false
            },

            selectAll() {
                this.selectedCompetencies = this.competencies.map(competency => competency.id)
            },

            unselectAll(session) {
                this.selectedCompetencies = []
            },

            list() {
                this.client.list().then(resp => {          
                    this.feedbacks = resp.data.data
                })
            },
        }
    }
</script>

<style scoped>

    .filter >>> .form-group {
        margin-bottom: 0;
    }
    .filter >>> .el-select.select-info .el-select__tags .el-tag {
        background: #5e72e4;
    }
    .description {
        white-space: pre-wrap;
    }
    @media (min-width: 992px) {
        .timeline-one-side .timeline-content {
            max-width: none;
        }
    }
    .timeslot-block {
        margin-bottom: 10px;
    }
    .feedback-block {
        margin-bottom: 30px;
    }

</style>
